// extracted by mini-css-extract-plugin
export default {"header":"Header_header__aT8IF","logo":"Header_logo__Ew5nE"};